import { Directive, ElementRef, HostListener } from '@angular/core';

// For iOS, to prevent scrolling on the window element,
// we need to prevent any nested element with scroll from
// reaching the top and bottom of it's scroll.
@Directive({
    selector: '[iosNestedScroll]'
})
export class IosNestedScrollDirective {
    constructor(private _nativeScrollElement: ElementRef) {}

    @HostListener('scroll') public onScroll(): void {
        this.scrollToPreventBounce();
    }

    public scrollToPreventBounce() {
        // Do nothing for devices/browsers that do not support scrollTo.
        if (!this._nativeScrollElement.nativeElement.scrollTo) {
            return;
        }

        const { scrollTop, offsetHeight, scrollHeight } = this._nativeScrollElement.nativeElement;

        // If at top, bump down 1px
        if (scrollTop <= 0) {
            this._nativeScrollElement.nativeElement.scrollTo(0, 1);
            return;
        }

        // If at bottom, bump up 1px
        if (scrollTop + offsetHeight >= scrollHeight) {
            this._nativeScrollElement.nativeElement.scrollTo(0, scrollHeight - offsetHeight - 1);
        }
    }
}
